/**
 * Checks if the given value is an array.
 */
export const isArray = (value: any): value is any[] => {
  return Array.isArray(value)
}

/**
 * Checks if the given value is a Date object.
 */
export const isDate = (value: any): value is Date => {
  return value instanceof Date
}

/**
 * Safely gets a nested property from an object using dot notation or array path.
 * Returns undefined if path doesn't exist or if defaultValue is provided.
 *
 * @example
 * get({ a: { b: { c: 1 } } }, 'a.b.c') // 1
 * get({ a: { b: { c: 1 } } }, ['a', 'b', 'c']) // 1
 * get({ a: { b: { c: 1 } } }, 'a.b.d') // undefined
 * get({ a: { b: { c: 1 } } }, 'a.b.d', 'default') // 'default'
 * get(null, 'a.b.c') // undefined
 */
export const get = <T = any, R = any>(
  obj: T | null | undefined,
  path: string | string[],
  defaultValue?: R,
): R => {
  if (obj == null) return defaultValue as R

  const keys = Array.isArray(path) ? path : path.split('.')
  let result: any = obj

  for (const key of keys) {
    if (result == null || typeof result !== 'object') {
      return defaultValue as R
    }
    result = result[key]
  }

  return result !== undefined ? result : (defaultValue as R)
}
